import { createSelector } from 'reselect'

export const getIsCategoryPage = createSelector(
  (state) => state && state.categories && state.categories.isCategoryPage ? state.categories.isCategoryPage : false,
  (isCategoryPage) => isCategoryPage
)
